export default __webpack_public_path__ + "static/media/Voldemort's Wand - Img - Wip 1_02.d4e9b96b.jpg";